module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-actions', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('v-icon', [_vm._v("stop")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.inError
    },
    on: {
      "click": function($event) {
        _vm.runStop()
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.stop ? 'play_arrow' : 'pause'))])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": _vm.inError || !_vm.stop
    },
    on: {
      "click": function($event) {
        _vm.step()
      }
    }
  }, [_c('v-icon', [_vm._v("redo")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.cycleCount) + " cycles")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.sendIT
    }
  }, [_vm._v("IT")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticClass: "subheading",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn-toggle', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.flagArray),
      callback: function($$v) {
        _vm.flagArray = $$v
      },
      expression: "flagArray"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("Z")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("V")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("C")])], 1)], 1)], 1), _vm._v(" "), (_vm.showIO) ? _c('v-card', [_c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticClass: "subheading"
  }, [_vm._v("Leds")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.leds), function(value, index) {
    return _c('v-icon', {
      key: 'led' + index
    }, [_vm._v("\n                  " + _vm._s(_vm.leds[15 - index] ? 'radio_button_checked' : 'radio_button_unchecked') + "\n               ")])
  }))], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticClass: "subheading"
  }, [_vm._v("Switches")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.switches), function(value, index) {
    return _c('v-icon', {
      key: 'sw' + index,
      on: {
        "click": function($event) {
          _vm.swClick(15 - index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.switches[15 - index] ? 'check_box' : 'check_box_outline_blank') + "\n               ")])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', [_c('v-divider'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('craps-memory-editor', {
    staticClass: "memory-editor",
    attrs: {
      "title": 'Memory',
      "memorydict": _vm.memoryDict,
      "currentaddress": _vm.currentAddress,
      "breakpoints": _vm.breakpoints,
      "version-no": _vm.versionNo
    },
    on: {
      "breakpoint": _vm.onBreakpointChange
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('craps-registers-editor', {
    staticClass: "memory-editor",
    attrs: {
      "title": 'Registers',
      "registerValues": _vm.registerValues
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb8a0c7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/craps/CrapsSimulator.vue
// module id = 1217
// module chunks = 1